  import { Component,ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
  import { ButtonModule } from 'primeng/button';
  import { CardModule } from 'primeng/card';
  import { CommonModule, CurrencyPipe } from '@angular/common';
  import { Experience } from '../../../services/interfaces/experiences';
import { AvailabilityTimePeople } from 'app/services/interfaces/availabilities';

  @Component({
    selector: 'app-people-dropdown',
    standalone: true,
    imports: [ButtonModule, CardModule, CommonModule, CurrencyPipe],
    templateUrl: './people-dropdown.component.html',
    styleUrls: ['./people-dropdown.component.scss']
  })
  export class PeopleDropdownComponent implements OnInit, OnChanges {
    @Input() experience: Experience | undefined;
    @Input() isLanguageDateAndTimeSelected: boolean | undefined ;
    @Input() timePeopleInfo!: AvailabilityTimePeople;
    @Input() isReservation!: boolean;
    @Output() isValidChange = new EventEmitter<boolean>();
    @Output() totalPriceChange = new EventEmitter<number>();
    @Output() numberOfPeopleChange = new EventEmitter<number>();
    @Output() labelCountsChange = new EventEmitter<number[]>();
    dropdownOpen: boolean = false;
    numberOfPeople: number = 0;

    labelCounts: number[] = [];
    isValid: boolean = false;
    totalPeople: number = 0;
    totalCounts: { label: string, count: number }[] = [];
    dropdownLabel: string = 'Persone';  
    totalPrice: number = 0;
    minParties: number = 0;
    maxParties: number = 0;
    console = console; // Esponi console al template
    private isInternalClick: boolean = false; // Flag per prevenire chiusura durante click interni
    constructor(private cp: CurrencyPipe, private eRef: ElementRef, private cdr: ChangeDetectorRef) {}

    // Getter per semplificare il template
    get basePrice(): { price: number; title: string } | null {
      if (!this.experience?.prices) return null;
      const basePriceObj = this.experience.prices.find(p => p.priceType === 'LABEL' && p.position === 0);
      if (!basePriceObj) return null;
      return {
        price: basePriceObj.price,
        title: basePriceObj.priceTitle || basePriceObj.priceDescription || 'Prezzo'
      };
    }

    get extraPrices(): Array<{ price: number; title: string }> {
      if (!this.experience?.prices) return [];
      return this.experience.prices
        .filter(p => p.priceType === 'LABEL' && p.position > 0)
        .sort((a, b) => (a.position || 0) - (b.position || 0))
        .map(p => ({
          price: p.price,
          title: p.priceTitle || p.priceDescription || 'Extra'
        }));
    }

    ngOnInit() {
      this.initializeValues();
      document.addEventListener('click', this.onDocumentClick.bind(this));
      
    }
    
    ngOnChanges(changes: SimpleChanges) {
      // Verifica se 'timePeopleInfo' o 'experience' sono cambiati effettivamente
      if (changes['timePeopleInfo'] && !changes['timePeopleInfo'].isFirstChange() || 
          changes['experience'] && !changes['experience'].isFirstChange()) {
        this.initializeValues();
      }
    
      // Verifica se 'isReservation' è cambiato
      if (changes['isReservation'] && changes['isReservation'].previousValue !== changes['isReservation'].currentValue) {
        this.initializeValues();
      }
    }
    
    initializeValues() {
      if (this.isReservation) {
        this.minParties = this.timePeopleInfo.minParties;
        this.maxParties = this.timePeopleInfo.maxParties - this.timePeopleInfo.occupiedCount;
      } else {
        this.minParties = this.experience?.details?.minPartiesToEnable ?? 0;
        this.maxParties = this.experience?.details?.maxParties ?? 0;
      }
    
      if (this.experience?.prices) {
        // Inizializza labelCounts solo se non è già inizializzato o se la lunghezza è cambiata
        const labelPrices = this.experience.prices.filter(p => p.priceType === 'LABEL' && p.position > 0);
        
        if (this.labelCounts.length !== labelPrices.length) {
          // Solo se il numero di prezzi è cambiato, reinizializza
          this.labelCounts = labelPrices.map(() => 0);
        } else if (this.labelCounts.length === 0) {
          // Inizializza solo se è vuoto
          this.labelCounts = labelPrices.map(() => 0);
        }
        // Altrimenti preserva i valori esistenti
      }
    
      this.calculateTotalPrice();
    }
  
    onDocumentClick(event: MouseEvent) {
      // Se è un click interno, ignora
      if (this.isInternalClick) {
        this.isInternalClick = false;
        return;
      }
      
      const target = event.target as HTMLElement;
      
      // Non chiudere se il click è dentro il dropdown
      if (this.eRef.nativeElement.contains(target)) {
        return;
      }
      
      // Chiudi solo se il click è fuori dal dropdown
      this.dropdownOpen = false;
    }
    formatCurrencyCents(number: number | undefined): string {
      if (number == null) number = 0;
      const numEur = number / 100;
      return this.cp.transform(numEur, 'EUR', 'symbol', '1.0-0') || "";
    }

    calculateTotalPrice() {
      // Prezzo base dal primo prezzo di tipo LABEL
      const basePriceObj = this.experience?.prices?.find(p => p.priceType === 'LABEL' && p.position === 0);
      let basePrice = (basePriceObj?.price ?? 0) * this.numberOfPeople;

      let extraPrice = 0;

      // Calcola il prezzo degli extra (prezzi LABEL con position > 0)
      if (this.experience?.prices) {
        const labelPrices = this.experience.prices
          .filter(p => p.priceType === 'LABEL' && p.position > 0)
          .sort((a, b) => (a.position || 0) - (b.position || 0));
        for (let i = 0; i < this.labelCounts.length && i < labelPrices.length; i++) {
          const count = this.labelCounts[i];
          const priceObj = labelPrices[i];
          extraPrice += count * (priceObj.price || 0);
        }
      }

      this.totalPrice = basePrice + extraPrice;
      this.totalPriceChange.emit(this.totalPrice); // Emetti il prezzo totale aggiornato
    }
    getPeopleData() {
      return {
        numberOfPeople: this.numberOfPeople,
        labelCounts: this.labelCounts,
        totalPrice: this.totalPrice
      };
    }
    formatTotalPrice(): string {
      return this.formatCurrencyCents(this.totalPrice);
    }

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      this.updateValidation();
    }

    incrementGlobal() {
      // Marca come click interno per prevenire chiusura dropdown
      this.isInternalClick = true;
      
      const labelCountsTotal = this.labelCounts.reduce((acc, count) => acc + count, 0);
      const currentTotal = this.numberOfPeople + labelCountsTotal;
      
      // Verifica che ci sia spazio per incrementare considerando anche i labelCounts
      if (currentTotal < this.maxParties) {
        this.numberOfPeople++;
        this.numberOfPeopleChange.emit(this.numberOfPeople);
        this.calculateTotalPrice();
        this.updateValidation();
      }
    }

    decrementGlobal() {
      // Marca come click interno per prevenire chiusura dropdown
      this.isInternalClick = true;
      
      if (this.numberOfPeople > 0) {
        this.numberOfPeople--;
        this.numberOfPeopleChange.emit(this.numberOfPeople); // Emit the updated numberOfPeople
        this.labelCountsChange.emit(this.labelCounts); // Emit the updated labelCounts
        this.calculateTotalPrice();
        this.updateValidation();
      }
    }

    increment(index: number) {
      // Marca come click interno per prevenire chiusura dropdown
      this.isInternalClick = true;
      
      if (index >= 0 && index < this.labelCounts.length) {
        const currentTotal = this.numberOfPeople + this.labelCounts.reduce((acc, count) => acc + count, 0);
        
        if (currentTotal < this.maxParties) {
          // Crea un nuovo array per assicurare la change detection
          this.labelCounts = this.labelCounts.map((count, i) => i === index ? count + 1 : count);
          
          this.labelCountsChange.emit([...this.labelCounts]);
          this.calculateTotalPrice();
          this.updateValidation();
        }
      }
    }

    decrement(index: number) {
      // Marca come click interno per prevenire chiusura dropdown
      this.isInternalClick = true;
      
      if (index >= 0 && index < this.labelCounts.length && this.labelCounts[index] > 0) {
        // Crea un nuovo array per assicurare la change detection
        this.labelCounts = this.labelCounts.map((count, i) => i === index ? count - 1 : count);
        
        this.labelCountsChange.emit([...this.labelCounts]);
        this.calculateTotalPrice();
        this.updateValidation();
      }
    }

    updateValidation() {
      const minPeopletoBook = this.timePeopleInfo.minParties;
      let totalPeople = this.numberOfPeople + this.labelCounts.reduce((acc, count) => acc + count, 0);
      
      // Non modifichiamo più né labelCounts né numberOfPeople qui
      // Solo validazione pura
      this.isValid = totalPeople >= minPeopletoBook && totalPeople <= this.maxParties;
      
      if (totalPeople === 0) {
        this.isValid = false;
      }
    
      this.isValidChange.emit(this.isValid);
      this.updateDropdownLabel();
    }

    updateDropdownLabel() {
      // Prezzo base dal primo prezzo di tipo LABEL
      const basePriceObj = this.experience?.prices?.find(p => p.priceType === 'LABEL' && p.position === 0);
      const priceLabel = basePriceObj?.priceTitle || basePriceObj?.priceDescription || 'Prezzo';
      
      // Prezzi LABEL con position > 0 (extra)
      const labelPrices = this.experience?.prices?.filter(p => p.priceType === 'LABEL' && p.position > 0).sort((a, b) => (a.position || 0) - (b.position || 0)) || [];
      
      // Filtra solo i conteggi maggiori di 0
      const additionalCounts = this.labelCounts
        .map((count, index) => {
          if (count > 0 && labelPrices[index]) {
            const priceObj = labelPrices[index];
            const title = priceObj.priceTitle || priceObj.priceDescription || 'Extra';
            return `${count} ${title.toLowerCase()}`;
          }
          return null;
        })
        .filter(item => item !== null)
        .join(' + ');
      
      if (additionalCounts && additionalCounts.length > 0) {
        this.dropdownLabel = `<strong>${this.numberOfPeople} (${priceLabel}) + ${additionalCounts}</strong>`;
      } else {
        this.dropdownLabel = `<strong>${this.numberOfPeople} (${priceLabel})</strong>`;
      }
    }
    reset(): void {
      this.numberOfPeople = 0;
      // Crea un nuovo array invece di modificare quello esistente
      this.labelCounts = this.labelCounts.map(() => 0);
      this.isValid = false;
      this.totalPrice = 0;
      this.calculateTotalPrice();
      this.updateValidation();
      this.dropdownLabel = 'persone';
    }
  }
